import React from 'react';

import { FilterChipValue } from '../../../../library/filter-chips/filter-chips';
import Image from '../../../../library/image/image';
import Link from '../../../../library/link/link';
import Typography from '../../../../library/typography/typography';

import { useFitment, useMyStore } from '../../../../shared/hooks/hooks';

import { PLPProductFilters } from '../../types/plp-products';
import { FILTER_KEYS } from '../../../../shared/constants/filters';

import './winter-tires-banner.scss';

interface WinterTiresBannerProps {
  filters: PLPProductFilters[];
  formattedTireSize: string;
  selectedFilters: FilterChipValue[];
}

function WinterTiresBanner(props: WinterTiresBannerProps) {
  const { formattedTireSize, selectedFilters, filters } = props;
  const { myStore } = useMyStore();
  const { selectedFitment } = useFitment();

  const hasThreePeakFilter = filters
    ?.find(filter => filter?.categoryCode === 'quickFilters')
    ?.values?.find(
      value => value?.categoryCode === FILTER_KEYS.THREE_PEAK_MOUNTAIN
    );

  let isWinterFilterSelected = false;
  let is3PMSFilterSelected = false;

  for (const filter of selectedFilters) {
    isWinterFilterSelected =
      filter?.categoryCode === FILTER_KEYS.TIRE_CATEGORY &&
      filter?.valueCode === FILTER_KEYS.WINTER_TIRES;

    is3PMSFilterSelected =
      filter?.categoryCode === FILTER_KEYS.THREE_PEAK_MOUNTAIN;

    if (isWinterFilterSelected || is3PMSFilterSelected) {
      break;
    }
  }

  const showWinterBanner =
    !is3PMSFilterSelected &&
    !isWinterFilterSelected &&
    myStore &&
    myStore?.remainingWinterDays > 0 &&
    myStore?.winterStore &&
    (formattedTireSize || selectedFitment?.frontTireSize) &&
    !selectedFitment?.isStaggered &&
    !selectedFilters?.find(
      selectedFilter => selectedFilter?.valueCode === FILTER_KEYS.WINTER_TIRES
    );

  if (showWinterBanner) {
    return (
      <div styleName="container">
        <Typography styleName="cta" tag="div" weight="heavy">
          Looking for snow tires?&nbsp;&nbsp;
          <Link
            size="small"
            to={`${
              window.location.pathname
            }?q=%3AbestSeller-asc%3AtireCategory%3AwinterTires${
              hasThreePeakFilter ? '%3AthreePeakMountain-boolean%3AY' : ''
            }`}
          >
            Shop {formattedTireSize || selectedFitment?.frontTireSize} snow
            tires
          </Link>
        </Typography>
        <Image
          alt="Snow Tires"
          src="https://discounttire.scene7.com/is/image/discounttire/plp-snow-tires-composite?fmt=png-alpha&wid=232"
          styleName="img"
        />
      </div>
    );
  }

  return null;
}

export default WinterTiresBanner;
